import { EnumGTMEvents } from "services/tagManager/enums/enumGTMEvents";
import { FORM_LOCAL_STORAGE_KEY } from "../consts";
import { FormWrapper } from "../../../components/formWrapper";
import { getDtoFromStep1FormValues } from "../step1/useStep1Form/helpers";
import { getDtoFromStep2FormValues } from "../step2/useStep2Form/helper";
import { getDtoFromStep3FormValues } from "./useStep3Form/helper";
import { IStep1FormValues } from "../step1/useStep1Form/iStep1FormValues";
import { IStep2FormValues } from "../step2/useStep2Form/iStep2FormValues";
import { IStep3FormValues } from "./useStep3Form/iStep3FormValues";
import { LeadService } from "services/caju";
import { NextButton } from "../../../components/nextButton";
import { ProductList } from "./productsList";
import { QueuedUpdateContext } from "../queuedUpdateContext/context";
import { saveFieldsOnLocalStorage } from "../utils";
import { TagManagerService } from "services/tagManager";
import { Typography, Grid, Alert } from "@mui/material";
import { useStep3Form } from "./useStep3Form";
import React from "react";
import { generateHash } from "utils";

export interface Step3Props {
  onGoNext: (values: IStep3FormValues) => void;
  step1Values?: IStep1FormValues;
  step2Values?: IStep2FormValues;
}

export const Step3 = (props: Step3Props) => {
  const queueContext = React.useContext(QueuedUpdateContext);

  const form = useStep3Form({
    onSubmit: (values) => {
      const leadID = props?.step1Values?.email || "";
      let previousSteps = {};

      if (props.step1Values && props.step2Values) {
        previousSteps = {
          ...getDtoFromStep1FormValues(props.step1Values.email, {
            ...props.step1Values,
          }),
          ...getDtoFromStep2FormValues(
            props.step1Values.email,
            props.step2Values
          ),
        };
      }

      const data = {
        ...previousSteps,
        ...getDtoFromStep3FormValues(leadID, values),
      };

      queueContext.push(data, LeadService.saveLead, () =>
        localStorage.removeItem(FORM_LOCAL_STORAGE_KEY)
      );
      handleSubmitEvent();
      props.onGoNext(values);
    },
  });

  const handleSubmitEvent = async () => {
    const formatedEmail = (props.step1Values?.email ?? "")
      .toLowerCase()
      .replace(/s/g, "");
    const formatedPhone = (props.step1Values?.phone ?? "").replace?.(/\W/g, "");

    const emailHash = await generateHash(formatedEmail);
    const phoneHash = await generateHash(formatedPhone);

    const dtoData = getDtoFromStep3FormValues(
      props?.step1Values?.email || "",
      form.values
    );

    TagManagerService.push(
      EnumGTMEvents.PRODUCT_INFO_FORM_BTN_CONTINUE__CLICK,
      {
        interestSubscriptionProducts:
          dtoData.interestSubscriptionProducts || "",
        interestSolutions: dtoData.interestSolutions || "",
        email: emailHash,
        celular: phoneHash,
      }
    );
  };

  const handleOnBlur = (event: React.FocusEvent) => {
    if (event.target.tagName === "INPUT") form.handleBlur(event);

    saveFieldsOnLocalStorage(form.values);
  };

  return (
    <FormWrapper>
      <>
        <Grid item xs={12} md={6} sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            O que sua empresa está buscando?
          </Typography>
          <Typography variant="body1" color="dark.light">
            Você pode selecionar mais de uma das soluções abaixo:
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          direction={{ xs: "column-reverse", md: "row" }}
        >
          <Grid item xs={12} md={6}>
            <form data-cy="step3-form" onSubmit={form.handleSubmit}>
              <ProductList form={form} onBlur={handleOnBlur} />
              <NextButton type="submit" disabled={queueContext.loading} />
            </form>
          </Grid>
          <Grid item xs={0} md={1}></Grid>

          {form.touched.selectedProducts && form.errors.selectedProducts && (
            <Grid item xs={12} md={4}>
              <Alert severity="error" variant="outlined">
                {form.errors.selectedProducts}
              </Alert>
            </Grid>
          )}
        </Grid>
      </>
    </FormWrapper>
  );
};
